<template>
  <div class="timer">
    {{ timeText }}
  </div>
</template>
<script>
export default {
  props: {
    gameState: {
      type: String,
      default: 'start'
    }
  },
  data () {
    return {
      timerInterval: null,
      startTime: 0,
      seconds: 0,
      milliSeconds: 0,
      timeText: '00:00',
      currentState: 'start'
    }
  },
  watch: {
    gameState () {
      if (this.currentState !== this.gameState) {
        this.currentState = this.gameState
        this.handleGameState()
      }
    }
  },
  methods: {
    handleGameState () {
      switch (this.gameState) {
        case 'start':
          this.handleStart()
          break
        case 'playing':
          this.handlePlaying()
          break
        case 'finished':
          this.handleFinished()
          break
      }
    },

    resetTimer () {
      this.seconds = 0
      this.milliSeconds = 0
      this.setTimerText()
    },

    startTimer () {
      this.startTime = new Date().getTime()
      this.timerInterval = window.setInterval(() => {
        const time = new Date(new Date().getTime() - this.startTime)
        this.seconds = time.getSeconds()
        this.milliSeconds = Math.floor(time.getMilliseconds() / 10)
        this.setTimerText()
      }, 10)
    },

    setTimerText () {
      let secText = this.seconds.toString()
      let milliSecText = this.milliSeconds.toString()
      if (secText.length < 2) {
        secText = `0${secText}`
      }
      if (milliSecText.length < 2) {
        milliSecText = `0${milliSecText}`
      }
      this.timeText = `${secText}:${milliSecText}`
    },

    handleStart () {
      this.resetTimer()
      clearInterval(this.timerInterval)
    },

    handlePlaying () {
      this.startTimer()
    },

    handleFinished () {
      clearInterval(this.timerInterval)
    }
  }
}
</script>
<style lang="scss" scoped>
  .timer {
    width: 100%;
    position: absolute;
    bottom: 10px;
    text-align: center;
    font-size: 14px;
    color: $nos-op3-red;
    opacity: 0.7;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/GameTimer.vue